import { createOperation } from "../operations";

export const fetchOfferDataOperation = createOperation<void>("OFFERS/FETCH_OFFER_DATA", { showSpinner: true });
export const fetchAllOffersOperation = createOperation<void>("OFFERS/FETCH_ALL_OFFERS");
export const claimOfferOperation = createOperation<void>("OFFERS/CLAIM_OFFER", { showSpinner: true });
